import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';

import theme from 'styles/theme';
import { UserProvider } from 'contexts/UserContext';
import { FormProvider } from 'contexts/FormContext';

import App from './App';

const Root: React.FC = () => (
  <FormProvider>
    <UserProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </UserProvider>
  </FormProvider>
);

export default Root;
